/*
 * Caplansky's — cart guard.
 *
 * The box builder enforces 2 or 4 jars, but Dawn's cart page hands the customer
 * quantity steppers one screen later (main-cart-items.liquid, <quantity-input>).
 * So a built box of 4 can become 5, or 3 by removing a line, and the order is
 * then unpackable: jars ship in fixed packs.
 *
 * This blocks checkout on a jar count that cannot be made from the configured
 * pack sizes, and says which counts work. It does NOT hide the steppers --
 * the customer keeps full control of the cart and is told what to fix.
 *
 * FAILS OPEN, deliberately. Every path is wrapped: if the cart cannot be read,
 * or Dawn's markup has moved, or anything throws, the guard does nothing and
 * checkout proceeds. A guard that wrongly blocks every order is far worse than
 * the occasional unpackable one it exists to catch.
 *
 * Reachability is a real subset-sum over the pack sizes rather than an "is it
 * even" shortcut, so adding a 3-pack later needs no code change.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-cap-cart-guard]');
  if (!root) return;

  var ids, packs, MSG_CLASS = 'cap-cart-guard__msg';
  try {
    ids = JSON.parse(root.dataset.productIds || '[]');
    packs = (root.dataset.packs || '')
      .split(',')
      .map(function (n) { return parseInt(n, 10); })
      .filter(function (n) { return n > 0; });
  } catch (e) { return; }
  if (!ids.length || !packs.length) return;

  var guarded = {};
  ids.forEach(function (id) { guarded[String(id)] = true; });

  var timer = null;
  schedule();
  watch();

  /* Dawn re-renders the cart items via section rendering after a quantity
     change, with no public event we can rely on across versions. Watching the
     container is version-proof in a way that hooking its internals is not. */
  function watch() {
    try {
      var host = document.querySelector('#main-cart-items') || document.querySelector('cart-items');
      if (!host || !window.MutationObserver) return;
      new MutationObserver(schedule).observe(host, { childList: true, subtree: true });
    } catch (e) { /* no observer: the load-time check still stands */ }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(evaluate, 120);
  }

  function evaluate() {
    try {
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
        headers: { Accept: 'application/json' }
      })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (cart) {
          if (!cart || !cart.items) return release();
          var units = 0;
          cart.items.forEach(function (item) {
            if (guarded[String(item.product_id)]) units += item.quantity;
          });
          /* An empty cart, or one with none of the guarded products, is not
             ours to judge. */
          if (units === 0) return release();
          if (reachable(units)) return release();
          block(units);
        })
        .catch(release);
    } catch (e) { release(); }
  }

  /* Can `total` be made from the pack sizes, any number of each? */
  function reachable(total) {
    var ok = [true];
    for (var n = 1; n <= total; n++) {
      ok[n] = false;
      for (var i = 0; i < packs.length; i++) {
        if (n - packs[i] >= 0 && ok[n - packs[i]]) { ok[n] = true; break; }
      }
    }
    return !!ok[total];
  }

  function nearest(total) {
    var down = total, up = total;
    while (down > 0 && !reachable(down)) down--;
    while (up < total + 12 && !reachable(up)) up++;
    return { down: down > 0 ? down : null, up: up <= total + 12 ? up : null };
  }

  function ctas() {
    return {
      primary: document.querySelector('button[name="checkout"], input[name="checkout"]'),
      dynamic: document.querySelector('.cart__dynamic-checkout-buttons, .additional-checkout-buttons')
    };
  }

  function block(units) {
    try {
      var c = ctas();
      if (!c.primary) return;                     // markup moved: do not pretend
      c.primary.setAttribute('disabled', 'disabled');
      c.primary.setAttribute('aria-describedby', 'cap-cart-guard-msg');
      /* Accelerated checkout bypasses the button entirely, so it has to go too
         or the guard is decorative. */
      if (c.dynamic) c.dynamic.style.display = 'none';
      message(units, c.primary);
    } catch (e) { release(); }
  }

  function release() {
    try {
      var c = ctas();
      if (c.primary) {
        c.primary.removeAttribute('disabled');
        c.primary.removeAttribute('aria-describedby');
      }
      if (c.dynamic) c.dynamic.style.display = '';
      var old = document.querySelector('.' + MSG_CLASS);
      if (old && old.parentNode) old.parentNode.removeChild(old);
    } catch (e) { /* nothing to release */ }
  }

  function message(units, primary) {
    var near = nearest(units);
    var options = [];
    if (near.down) options.push(String(near.down));
    if (near.up && near.up !== near.down) options.push(String(near.up));

    var text = (root.dataset.message || 'Jars ship in fixed packs.')
      .replace('[count]', String(units))
      .replace('[packs]', packs.join(' or '))
      .replace('[nearest]', options.join(' or '));

    var el = document.querySelector('.' + MSG_CLASS);
    if (!el) {
      el = document.createElement('div');
      el.className = MSG_CLASS;
      el.id = 'cap-cart-guard-msg';
      el.setAttribute('role', 'status');
      /* Sits directly above the checkout button: the thing it is explaining. */
      var host = primary.closest('.cart__ctas') || primary.parentNode;
      host.parentNode.insertBefore(el, host);
    }
    el.textContent = text;
  }
})();
